export const statusModel = [
  { value: null, text: 'All' },
  { value: 'PAID', text: 'Paid' },
  { value: 'PARTIALLY_PAID', text: 'Partial Paid' },
  { value: 'IN_PROCESS', text: 'In Process' },
  { value: 'REJECTED', text: 'Rejected' },
  { value: 'REVIEW', text: 'Review' }
];
